import { render } from "./ColorAccent.vue?vue&type=template&id=fe2a95a4&scoped=true&ts=true"
import script from "./ColorAccent.vue?vue&type=script&lang=ts"
export * from "./ColorAccent.vue?vue&type=script&lang=ts"

import "./ColorAccent.vue?vue&type=style&index=0&id=fe2a95a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe2a95a4"]])

export default __exports__